export default {
  borderRadius: '6px',
  spacing: 8
};
